import React from 'react';
import { t } from '@sm/intl';
import { DetailsFeatureRowPackages } from '~app/pages/Pricing/transformers/details/types';
import PackageDefs from '~app/pages/Pricing/lib/packages/packageDefs';

import { usePricingExperiments } from '~shared/hooks/usePricingExperiments';
import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import useGrow2529CategoryStyles from '../../../experiments/grow_2529_forms/components/DetailsCategories/useStyles';
import useCategoryStyles from './useStyles';
import COPY from './copy';

export default function FeatureCell(pkg: DetailsFeatureRowPackages): JSX.Element {
  const { uiExperiment, priceExperiment } = usePricingExperiments();
  const isInGrow2629Treatment =
    (priceExperiment.hasAssignment &&
      priceExperiment.experimentName === EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.name) ||
    (uiExperiment.hasAssignment && uiExperiment.experimentName === EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.name);

  const styles = useCategoryStyles({ packageName: pkg.packageName });
  const grow2529styles = useGrow2529CategoryStyles({ packageName: pkg.packageName });
  const stylesToUse = isInGrow2629Treatment ? { ...styles, ...grow2529styles } : styles;

  const { Cell, Bullet, BulletInverse, Highlighted } = stylesToUse;
  let a11yValue = t(COPY.UNAVAILABLE);

  if (typeof pkg.value === 'string') {
    a11yValue = pkg.value;
  } else if (pkg.value) {
    a11yValue = t(COPY.AVAILABLE);
  }

  return (
    <div
      role="cell"
      aria-label={`${pkg.packageName} ${a11yValue}`}
      className={`${Cell} ${PackageDefs[pkg.packageName]?.highlighted ? Highlighted : ''}`}
      tabIndex={-1}
      data-testid="FeatureCell"
    >
      {typeof pkg.value === 'boolean'
        ? pkg.value && <span className={PackageDefs[pkg.packageName]?.highlighted ? BulletInverse : Bullet} />
        : pkg.value}
    </div>
  );
}
